import React from 'react'
import { fadeIn } from '../../../Functions/GlobalAnimations'
import { Col, Container, Row } from 'react-bootstrap'
import { m } from "framer-motion"
import Services from '../../Services/Services'
import { IssuesData1 } from './IssueSecData'
import { ParagraphComp } from '../../ParagraphComp/ParagraphComp'
const IssueSec = () => {
    return (
        <>
            <m.section className="bg-[#f7f7f7] max-sm:py-[70px] py-[70px] lg:py-[70px] md:py-[70px]  xs:py-[50px]" {...fadeIn}>
                <Container>
                    <Row className="justify-center">
                        <Col md={12} className="text-center mb-[3%]">
                            <h6 className="text-black font-extrabold max-sm:text-3xl text-4xl">Understand needs and issues from the ground</h6>
                            <ParagraphComp className='max-sm:text-lg text-black lg:w-[85%] m-auto' text='NPOs work in geographies that are underserved, be it in remote villages or in the midst of a metropolis. They address issues that seem invisible, unheard of, unimaginable… they work with people and entities who may themselves be unaware of their circumstances and rights. Read why NPOs do what they do!' />
                            
                        </Col>
                    </Row>
                    <Services grid="row-cols-1 row-cols-lg-3 row-cols-md-2 gap-y-10 justify-center" theme='service-style-02' className="" data={IssuesData1} animation={fadeIn} />
                </Container>
            </m.section>
        </>
    )
}

export default IssueSec